import {
  type DashRouteType,
  URL_RETAILER_SCOPED,
  URL_PARTNER_SCOPED,
  URL_APP_ADMIN,
  URL_SITE_SCOPED,
} from '@retailer-platform/dashboard/routing'

export const URL_RETAILER_COLLECTIONS = `${URL_RETAILER_SCOPED}/retailer-collections`
export const URL_RETAILER_COLLECTIONS_PARTNER_SCOPED = `${URL_PARTNER_SCOPED}/retailer-collections`
export const URL_RETAILER_COLLECTIONS_V3_PARTNER_SCOPED = `${URL_PARTNER_SCOPED}/retailer-collections/v3`
// Keep view / edit pages for v3 under retailer scoped for now due to permission control on get collection API through retailer id param
export const URL_RETAILER_COLLECTIONS_V3_RETAILER_SCOPED = `${URL_RETAILER_SCOPED}/retailer-collections/v3`

const URL_RETAILER_COLLECTIONS_LIST = `${URL_RETAILER_COLLECTIONS}/list`
const URL_RETAILER_COLLECTIONS_CREATE = `${URL_RETAILER_COLLECTIONS}/create`
const URL_RETAILER_COLLECTIONS_VIEW = `${URL_RETAILER_COLLECTIONS}/view/:id`
const URL_RETAILER_COLLECTIONS_EDIT = `${URL_RETAILER_COLLECTIONS}/edit/:id`

const URL_RETAILER_COLLECTIONS_V3_LIST = `${URL_RETAILER_COLLECTIONS_V3_PARTNER_SCOPED}/list`
const URL_RETAILER_COLLECTIONS_V3_VIEW = `${URL_RETAILER_COLLECTIONS_V3_RETAILER_SCOPED}/view/:id`
const URL_RETAILER_COLLECTIONS_V3_VIEW_GLOBAL = `${URL_RETAILER_COLLECTIONS_V3_PARTNER_SCOPED}/view/:id`
const URL_RETAILER_COLLECTIONS_V3_CREATE = `${URL_RETAILER_COLLECTIONS_V3_PARTNER_SCOPED}/create`
const URL_RETAILER_COLLECTIONS_V3_CLONE = `${URL_RETAILER_COLLECTIONS_V3_PARTNER_SCOPED}/clone/:id`
const URL_RETAILER_COLLECTIONS_V3_EDIT = `${URL_RETAILER_COLLECTIONS_V3_RETAILER_SCOPED}/edit/:id`

const URL_RETAILER_COLLECTIONS_FLYERS_CREATE = `${URL_RETAILER_COLLECTIONS}/flyers/create`

// Updated flyers routes to use partner-scoped URLs
const URL_RETAILER_COLLECTIONS_FLYERS = `${URL_RETAILER_COLLECTIONS_PARTNER_SCOPED}/flyers`
const URL_RETAILER_COLLECTIONS_FLYERS_BUILD = `${URL_RETAILER_COLLECTIONS_PARTNER_SCOPED}/flyers/build/:id`
const URL_RETAILER_COLLECTIONS_FLYERS_REVIEW = `${URL_RETAILER_COLLECTIONS_PARTNER_SCOPED}/flyers/review/:key`
const URL_RETAILER_COLLECTIONS_FLYERS_VALIDATION = `${URL_RETAILER_COLLECTIONS_PARTNER_SCOPED}/flyers/validation/:id`

// Digital Flyer routes
const URL_RETAILER_COLLECTIONS_DIGITAL_FLYER = `${URL_RETAILER_COLLECTIONS_PARTNER_SCOPED}/digital-flyers`
const URL_RETAILER_COLLECTIONS_DIGITAL_FLYER_REVIEW = `${URL_RETAILER_COLLECTIONS_PARTNER_SCOPED}/digital-flyers/review/:key`
const URL_RETAILER_COLLECTIONS_FLYERS_PAGE_BUILDER = `${URL_RETAILER_COLLECTIONS}${URL_SITE_SCOPED}/digital-flyers/:flyerId/page-builder/:id?`

// Omelet routes - Updated to use partner-scoped URLs like flyers page
const URL_RETAILER_COLLECTIONS_FLYERS_OMELET_RUN_VIEW = `${URL_RETAILER_COLLECTIONS_PARTNER_SCOPED}/flyers/omelet/run-view/:flyerGroupKey`
const URL_RETAILER_COLLECTIONS_FLYERS_OMELET_EDITOR = `${URL_RETAILER_COLLECTIONS_PARTNER_SCOPED}/flyers/omelet/editor`
const URL_RETAILER_COLLECTIONS_FLYERS_OMELET = `${URL_RETAILER_COLLECTIONS_PARTNER_SCOPED}/flyers/omelet`

// Admin routes
const URL_ADMIN_RETAILER_COLLECTIONS = `${URL_APP_ADMIN}/retailer-collections`
const URL_ADMIN_RETAILER_COLLECTIONS_LIST = `${URL_ADMIN_RETAILER_COLLECTIONS}/list`
const URL_ADMIN_RETAILER_COLLECTIONS_VIEW = `${URL_ADMIN_RETAILER_COLLECTIONS}/view/:id`
const URL_ADMIN_RETAILER_COLLECTIONS_CREATE = `${URL_ADMIN_RETAILER_COLLECTIONS}/create`
const URL_ADMIN_RETAILER_COLLECTIONS_EDIT = `${URL_ADMIN_RETAILER_COLLECTIONS}/edit/:id`

const URL_ADMIN_FEATURED_COLLECTION_SETS = `${URL_ADMIN_RETAILER_COLLECTIONS}/featured-collection-sets`
const URL_ADMIN_FEATURED_COLLECTION_SETS_LIST = `${URL_ADMIN_FEATURED_COLLECTION_SETS}/list`
const URL_ADMIN_FEATURED_COLLECTION_SETS_CREATE = `${URL_ADMIN_FEATURED_COLLECTION_SETS}/create`
const URL_ADMIN_FEATURED_COLLECTION_SETS_EDIT = `${URL_ADMIN_FEATURED_COLLECTION_SETS}/edit/:id`
const URL_ADMIN_FEATURED_COLLECTION_SETS_VIEW = `${URL_ADMIN_FEATURED_COLLECTION_SETS}/view/:id`
// @hygen:inject scoped-urls

export type RetailerCollectionsV3ViewParams = {
  id: string
}

export type RetailerCollectionsV3EditParams = {
  id: string
}

export type RetailerCollectionsFlyersOmeletRunViewParams = {
  flyerGroupKey: string
}

export type RetailerCollectionsDigitalFlyerReviewParams = {
  key: string
}

export type RetailerCollectionsFlyersPageBuilderParams = {
  flyerId: string
  id?: string
}

export type DashRouteSet =
  | DashRouteType<'retailer-collections'>
  | DashRouteType<'retailer-collections-list'>
  | DashRouteType<'retailer-collections-browse'>
  | DashRouteType<'retailer-collections-view', RetailerCollectionsV3ViewParams>
  | DashRouteType<'retailer-collections-create'>
  | DashRouteType<'retailer-collections-edit', RetailerCollectionsV3EditParams>
  | DashRouteType<'retailer-collections-flyers'>
  | DashRouteType<'retailer-collections-flyers-build'>
  | DashRouteType<'retailer-collections-flyers-create'>
  | DashRouteType<'retailer-collections-flyers-review'>
  | DashRouteType<'retailer-collections-flyers-validation'>
  | DashRouteType<
      'retailer-collections-flyers-page-builder',
      RetailerCollectionsFlyersPageBuilderParams
    >
  | DashRouteType<
      'retailer-collections-flyers-omelet-run-view',
      RetailerCollectionsFlyersOmeletRunViewParams
    >
  | DashRouteType<'retailer-collections-flyers-omelet-editor'>
  | DashRouteType<'retailer-collections-flyers-omelet'>
  | DashRouteType<'retailer-collections-digital-flyers'>
  | DashRouteType<
      'retailer-collections-digital-flyers-review',
      RetailerCollectionsDigitalFlyerReviewParams
    >
  | DashRouteType<'retailer-collections-v3'>
  | DashRouteType<'retailer-collections-v3-list'>
  | DashRouteType<'retailer-collections-v3-view', RetailerCollectionsV3ViewParams>
  | DashRouteType<'retailer-collections-v3-view-global', RetailerCollectionsV3ViewParams>
  | DashRouteType<'retailer-collections-v3-create'>
  | DashRouteType<'retailer-collections-v3-clone', { id: string }>
  | DashRouteType<'retailer-collections-v3-edit', RetailerCollectionsV3EditParams>
  | DashRouteType<'app-admin-retailer-collections'>
  | DashRouteType<'app-admin-retailer-collections-list'>
  | DashRouteType<'app-admin-retailer-collections-view', RetailerCollectionsV3ViewParams>
  | DashRouteType<'app-admin-retailer-collections-create'>
  | DashRouteType<'app-admin-retailer-collections-edit', RetailerCollectionsV3EditParams>
  | DashRouteType<'app-admin-featured-collection-sets-list'>
  | DashRouteType<'app-admin-featured-collection-sets-create'>
  | DashRouteType<'app-admin-featured-collection-sets-edit', { id: string }>
  | DashRouteType<'app-admin-featured-collection-sets-view', { id: string }>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'retailer-collections': URL_RETAILER_COLLECTIONS,
  'retailer-collections-browse': URL_RETAILER_COLLECTIONS_LIST,
  'retailer-collections-list': URL_RETAILER_COLLECTIONS_LIST,
  'retailer-collections-view': URL_RETAILER_COLLECTIONS_VIEW,
  'retailer-collections-create': URL_RETAILER_COLLECTIONS_CREATE,
  'retailer-collections-edit': URL_RETAILER_COLLECTIONS_EDIT,

  'retailer-collections-flyers': URL_RETAILER_COLLECTIONS_FLYERS,
  'retailer-collections-flyers-build': URL_RETAILER_COLLECTIONS_FLYERS_BUILD,
  'retailer-collections-flyers-create': URL_RETAILER_COLLECTIONS_FLYERS_CREATE,
  'retailer-collections-flyers-review': URL_RETAILER_COLLECTIONS_FLYERS_REVIEW,
  'retailer-collections-flyers-validation': URL_RETAILER_COLLECTIONS_FLYERS_VALIDATION,
  'retailer-collections-flyers-page-builder': URL_RETAILER_COLLECTIONS_FLYERS_PAGE_BUILDER,

  // Flyers Admin
  // Flyers Admin - Omelet
  'retailer-collections-flyers-omelet-run-view': URL_RETAILER_COLLECTIONS_FLYERS_OMELET_RUN_VIEW,
  'retailer-collections-flyers-omelet-editor': URL_RETAILER_COLLECTIONS_FLYERS_OMELET_EDITOR,
  'retailer-collections-flyers-omelet': URL_RETAILER_COLLECTIONS_FLYERS_OMELET,

  // Digital Flyers
  'retailer-collections-digital-flyers': URL_RETAILER_COLLECTIONS_DIGITAL_FLYER,
  'retailer-collections-digital-flyers-review': URL_RETAILER_COLLECTIONS_DIGITAL_FLYER_REVIEW,

  'retailer-collections-v3': URL_RETAILER_COLLECTIONS_V3_PARTNER_SCOPED,
  'retailer-collections-v3-list': URL_RETAILER_COLLECTIONS_V3_LIST,
  'retailer-collections-v3-view': URL_RETAILER_COLLECTIONS_V3_VIEW,
  'retailer-collections-v3-view-global': URL_RETAILER_COLLECTIONS_V3_VIEW_GLOBAL,
  'retailer-collections-v3-create': URL_RETAILER_COLLECTIONS_V3_CREATE,
  'retailer-collections-v3-clone': URL_RETAILER_COLLECTIONS_V3_CLONE,
  'retailer-collections-v3-edit': URL_RETAILER_COLLECTIONS_V3_EDIT,

  // Admin routes
  'app-admin-retailer-collections': URL_ADMIN_RETAILER_COLLECTIONS,
  'app-admin-retailer-collections-list': URL_ADMIN_RETAILER_COLLECTIONS_LIST,
  'app-admin-retailer-collections-view': URL_ADMIN_RETAILER_COLLECTIONS_VIEW,
  'app-admin-retailer-collections-create': URL_ADMIN_RETAILER_COLLECTIONS_CREATE,
  'app-admin-retailer-collections-edit': URL_ADMIN_RETAILER_COLLECTIONS_EDIT,
  'app-admin-featured-collection-sets-list': URL_ADMIN_FEATURED_COLLECTION_SETS_LIST,
  'app-admin-featured-collection-sets-create': URL_ADMIN_FEATURED_COLLECTION_SETS_CREATE,
  'app-admin-featured-collection-sets-edit': URL_ADMIN_FEATURED_COLLECTION_SETS_EDIT,
  'app-admin-featured-collection-sets-view': URL_ADMIN_FEATURED_COLLECTION_SETS_VIEW,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
